export default "/images/45bed1717d372d6dcb53c732a5f63202.avif";